module.exports = __webpack_public_path__ + "img/truck_home.ea17a2bf.png";